<template>
  <div>
    <slot name="map" />
    <div v-if="title" :class="$style.header">
      <BaseHeading :semantic-level="1">
        {{ title }}
      </BaseHeading>
    </div>
    <div :class="$style.body">
      <slot name="main" />
      <ButtonGroup
        v-if="hasButtons"
        :class="[largeButtonMargin ? $style.largeButtonMargin : {}]"
      >
        <slot name="buttons" />
      </ButtonGroup>
    </div>
  </div>
</template>
<script setup lang="ts">
import BaseHeading from '~/base/components/heading/Heading.vue'
import ButtonGroup from '~/base/components/buttonGroup/ButtonGroup.vue'

interface BodyProps {
  title?: string
  sub?: string
  largeButtonMargin?: boolean
}

const { title, largeButtonMargin = false } = defineProps<BodyProps>()
const slots = useSlots()
const hasButtons = computed(() => slots.buttons !== undefined)
</script>
<style module>
:global(#app) {
  display: grid;
  grid-template-rows: 1fr auto;
  min-height: 100vh;
}

.header {
  margin: 0;
  padding: 12px 24px;
  background: var(--color-grey1);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80px;

  @media screen and (min-width: 740px) {
    min-height: var(--layout-header-height-desktop);
    border-radius: 4px 4px 0 0;
  }
}

.body {
  margin: 0 auto var(--space-lg);
  padding: 24px;

  @media screen and (min-width: 740px) {
    padding: 36px 140px;
  }
}

.largeButtonMargin {
  margin-top: var(--space-md);
}
</style>
